import { createSlice } from '@reduxjs/toolkit';

import { MenuInitialState } from './initialState';

const initialState = MenuInitialState;

const MenuSlice = createSlice({
  name: 'Menu',
  initialState,
  reducers: {
    setRawMenu: (state, action) => {
      state.fetchUserMenu.rawMenu = action.payload;
    },
    setIsLoadMenuSuccess: (state, action) => {
      state.fetchUserMenu.isLoadMenuSuccess = action.payload;
    },
  },
});

export const { setRawMenu, setIsLoadMenuSuccess } = MenuSlice.actions;

export default MenuSlice.reducer;
